import * as React from "react"
import * as styles from "./bulkText.module.scss"

const Hero = ({ content }: { content: JSX.Element }): JSX.Element => (
  <div className={styles.pageContainer}>{content}</div>
)

export default Hero
